var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraSvgrepo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M295,160c-74.439,0-135,60.561-135,135s60.561,135,135,135s135-60.561,135-135S369.439,160,295,160z M295,400 c-57.897,0-105-47.103-105-105c0-57.897,47.103-105,105-105c57.897,0,105,47.103,105,105C400,352.897,352.897,400,295,400z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,235c-33.084,0-60,26.916-60,60s26.916,60,60,60s60-26.916,60-60S328.084,235,295,235z M295,325 c-16.542,0-30-13.458-30-30s13.458-30,30-30s30,13.458,30,30S311.542,325,295,325z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,100h-0.076l-42.5-100H207.577l-42.5,100H65c-35.841,0-65,29.159-65,65v260c0,35.841,29.159,65,65,65h360 c35.841,0,65-29.159,65-65V165C490,129.159,460.841,100,425,100z M227.423,30h135.153l29.75,70H197.674L227.423,30z M100,460H65 c-19.299,0-35-15.701-35-35V190h70V460z M100,160H30.363c2.434-16.938,17.036-30,34.637-30h35V160z M460,425 c0,19.299-15.701,35-35,35H130V130h295c19.299,0,35,15.701,35,35V425z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraSvgrepo);
export default __webpack_public_path__ + "static/media/camera-svgrepo.193f26587a222479af01b683f3e59d24.svg";
export { ForwardRef as ReactComponent };